module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/katie-image-e4664382d6daa9f645609b50956993a6.jpg";